export enum EApiErrorCode {
  INVALID_TOKEN = 'INVALID_TOKEN',
  USER_HAS_INVITATION = 'USER_HAS_INVITATION',
  INVITE_NOT_FOUND = 'INVITE_NOT_FOUND',
  INVITE_EXPIRED = 'INVITE_EXPIRED',
  INVITE_USED = 'INVITE_USED',
  SSO_INVITE_PENDING_NOT_FOUND = 'SSO_INVITE_PENDING_NOT_FOUND',
  AZURE_INVALID_ISSUER = 'AZURE_INVALID_ISSUER',
  AZURE_NO_EMAIL = 'AZURE_NO_EMAIL',
  AZURE_TENANT_MISMATCH = 'AZURE_TENANT_MISMATCH',
  AZURE_OID_MISMATCH = 'AZURE_OID_MISMATCH',
  AZURE_INVITE_EMAIL_MISMATCH = 'AZURE_INVITE_EMAIL_MISMATCH',
  AZURE_AUTH_FAILED = 'AZURE_AUTH_FAILED',
}
